import { Component, Input, SimpleChanges } from '@angular/core';
import { ISparkleData } from '@services/datapoints-data.service';

@Component({
  selector: 'app-sparkle-line',
  templateUrl: './sparkle-line.component.html',
  styleUrls: ['./sparkle-line.component.scss']
})
export class SparkleLineComponent {

  // LineData comes in as a JSON string (e.g. '{"values":[1,2,3,4,5]}')
  @Input() LineData: string = '';

  public data: ISparkleData = { values: [] };

  width = 100;
  height = 30;
  points = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['LineData'] && this.LineData) {
      try {
        this.data = JSON.parse(this.LineData) as ISparkleData;
        this.generatePoints();
      } catch (err) {
        console.error('Invalid JSON for LineData:', this.LineData, err);
      }
    }
  }

  private generatePoints(): void {
    if (!this.data.values.length) {
      this.points = '';
      return;
    }

    const values = this.data.values;
    const max = Math.max(...values);
    const min = Math.min(...values);
    const range = max - min || 1;

    // Scale values to fit SVG height
    const scaled = values.map((v, i) => {
      const x = (i / (values.length - 1)) * this.width;
      const y = this.height - ((v - min) / range) * this.height;
      return `${x},${y}`;
    });

    this.points = scaled.join(' ');
  }
}
